window.addEventListener("load", (event) => {
  this.btnInfo = document.querySelector("#btn-info");
  this.btnBack = document.querySelector("#btn-back");
  this.checkout = document.querySelector("#checkout");
  this.btnCheckoutOutlet = document.querySelector("#btn-checkout-outlet");
  this.cartItemsHolder = document.querySelector("#cartItemsHolderOutlet");
  this.cartItemsInfo = document.querySelector("#cartItemsInfo");

  this.outletNotification = document.querySelector("#outlet-notification");
  this.outletLoading = document.querySelector("#outlet-loading");
  this.outletContent = document.querySelector("#outlet-content");
  this.filterGrid = document.querySelector(".grid.is-loaded");
  this.loadMore = document.querySelector(".btn--loadmore");
  this.collection__filters = document.querySelector(".collection__filters");
  this.countCurrent = document.querySelector("#info_collection-current");
  this.countMax = document.querySelector("#info_collection-max");
  this.bodyHTML = document.querySelector("body");

  startLoading();

  const urlParams = new URLSearchParams(window.location.search);
  this.type = urlParams.get("type");
  this.curentPage = 1;
  this.nextPage = 1;
  this.totalPage = 1;

  this.sliderOne = document.getElementById("slider-1");
  this.sliderTwo = document.getElementById("slider-2");
  this.displayValOne = document.getElementById("range1");
  this.displayValTwo = document.getElementById("range2");
  this.minGap = 50000;
  this.sliderTrack = document.querySelector(".slider-track");
  this.sliderMaxValue = 0;

  fetch(`https://api.ipify.org/`)
    .then((response) => response.text())
    .then((textIP) => {
      this.textIP = textIP;
      getBoPhan();
      countQty();
    });
});

function clickColor(gridItemID, color, template_id, image_url) {
  const gridItem = document.querySelector(`#${gridItemID}`);
  const sizeList = gridItem.querySelectorAll(`span[data-template-id="${template_id}"]`);
  const priceList = gridItem.querySelectorAll(`div.price[data-template-id="${template_id}"]`);
  const colorList = gridItem.querySelectorAll(`.swatch__label`);
  const imageList = gridItem.querySelectorAll("[data-product-image]");
  const productID = gridItem.querySelector(`span.is-check[data-template-id="${template_id}"][data-color="${color}"]`)?.getAttribute("data-product-id");
  colorList.forEach((item) => {
    if (item.getAttribute("data-swatch") != color) {
      item.classList.remove("is-check");
    } else {
      item.classList.add("is-check");
    }
  });
  sizeList.forEach((size) => {
    if (size.getAttribute("data-color") == color) {
      size.classList.remove("hidden");
    } else {
      size.classList.add("hidden");
    }
  });
  priceList.forEach((price) => {
    if (productID == price.getAttribute("data-product-id")) {
      price.classList.remove("hidden");
    } else {
      price.classList.add("hidden");
    }
  });
  imageList.forEach((image) => {
    if (color == image.getAttribute("data-color")) {
      image.classList.add("product__media--featured-visible");
    } else {
      image.classList.remove("product__media--featured-visible");
    }
  });
}

function clickSize(gridItemID, color, product_id, template_id) {
  const gridItem = document.querySelector(`#${gridItemID}`);
  const sizeList = gridItem.querySelectorAll(`span[data-color="${color}"][data-template-id="${template_id}"]`);
  const priceList = gridItem.querySelectorAll(`div.price[data-template-id="${template_id}"]`);

  sizeList.forEach((size) => {
    if (size.getAttribute("data-product-id") != product_id) {
      size.classList.remove("is-check");
    } else {
      size.classList.add("is-check");
    }
  });

  priceList.forEach((price) => {
    if (product_id == price.getAttribute("data-product-id")) {
      price.classList.remove("hidden");
    } else {
      price.classList.add("hidden");
    }
  });
}

function quickButton(outletID) {
  const gridItem = document.querySelector(`#${outletID}`);
  const sizeSelect = gridItem.querySelector(".size .btn__inner.is-check:not(.hidden)");
  const productSelect = sizeSelect.getAttribute("data-product-id");
  const outletCart = JSON.parse(localStorage.getItem("outlet-cart"));
  const jsonItem = JSON.parse(sizeSelect.querySelector("noscript")?.textContent);
  const productVariant = `${jsonItem.color ? jsonItem.color : "Không màu"} ${jsonItem.size ? "/ " + jsonItem.size : ""}`;
  let jsonData = [
    {
      product_id: jsonItem.product_id,
      product_name: jsonItem.product_name,
      product_price_origin: jsonItem.gia_goc,
      product_price: jsonItem.gia_giam,
      product_variant: productVariant,
      product_qty: 1,
      max_qty: jsonItem.max_qty,
      image_url: jsonItem.image_url,
    },
  ];

  if (!outletCart) {
    addStorage(jsonData);
    opendCard();
  } else {
    const productExist = outletCart.map((x) => x.product_id).indexOf(jsonItem.product_id);
    if (productExist == -1) {
      jsonData = jsonData.concat(outletCart);
      addStorage(jsonData);
      opendCard();
    } else {
      const qty = (outletCart[productExist]["product_qty"] += 1);
      if (qty <= jsonItem.max_qty) {
        xuLyQty(jsonItem.product_id, 1);
        opendCard();
      } else {
        this.outletNotification.classList.remove("hidden");
        this.outletContent.classList.remove("hidden");
        this.outletNotification.querySelector(".title").innerHTML = "Thông báo";
        this.outletNotification.querySelector(".thong-bao").innerHTML = `${jsonItem.product_name} - ${productVariant} đã đạt số lượng mua tối đa ${jsonItem.max_qty} sản phẩm`;
        this.outletNotification.querySelector("#tiep-tuc-mua").classList.remove("hidden");
      }
    }
  }
}

function opendCard() {
  const cardItems = document.querySelector("#cart-drawer-outlet #cartItemsHolderOutlet");
  this.bodyHTML.classList.add("js-drawer-outlet");
  var htmlItem = "";
  const htmlCart = `
        <div id="item-product_id" class="cart__item cart__item--no-border aos-animate">
            <div class="cart__item__image">
                <a>
                    <figure class="lazy-image lazy-image--cover">
                        <img src="image_url" width="200" height="250" loading="eager" class="img-object-cover" />
                    </figure>
                </a>
            </div>
            <div class="cart__item__content">
                <div class="cart__item__content-inner">
                    <div class="cart__item__info">
                        <p class="cart__item__title">product_name</p>
        
                        <div class="cart__item__meta">
                            <p class="cart__item__selected-options">
                                <span>product_variant</span>
                            </p>
                        </div>
                    </div>
                    <p class="cart__item__price"><span id="price-product_id">product_price</span> ₫</p>
                </div>
                <div class="cart__item__bottom">
                    <div class="cart__item__quantity">
                        <button type="button" class="cart__item__quantity-minus" onclick="removeQty(product_id);">
                            <span class="visually-hidden">Decrease Quantity</span>
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-toggle-minus" viewBox="0 0 192 192"><path d="M30 96h132" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </button>
                        <input type="number" id="qty-product_id" class="cart__item__quantity-field" value="product_qty" />
                        <button type="button" class="cart__item__quantity-plus" onclick="plusQty(product_id, max_qty);">
                            <span class="visually-hidden">Increase Quantity</span>
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-toggle-plus" viewBox="0 0 192 192">
                                <path d="M30 96h132M96 30v132" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </button>
                    </div>
                    <button class="cart__item__remove" title="Xoá" onclick="removeItem(product_id);">
                        <span>Xoá</span>
                    </button>
                </div>
            </div>
        </div>
    `;
  const outletStorage = JSON.parse(localStorage.getItem("outlet-cart"));
  if (outletStorage) {
    outletStorage.forEach((item) => {
      htmlItem += htmlCart
        .replaceAll("product_id", item.product_id)
        .replaceAll("product_name", item.product_name)
        .replaceAll("image_url", item.image_url)
        .replaceAll("product_price", new Intl.NumberFormat().format(parseInt(item.product_price) * item.product_qty))
        .replaceAll("product_qty", item.product_qty)
        .replaceAll("max_qty", item.max_qty)
        .replaceAll("product_variant", item.product_variant);
    });
    cardItems.innerHTML = htmlItem;
  }
  countQty();
}

function closeCard() {
  this.bodyHTML.classList.remove("js-drawer-outlet");
  outletBackCart();
}

function addStorage(jsonData) {
  localStorage.setItem("outlet-cart", [JSON.stringify(jsonData)]);
  countQty();
}

function xuLyQty(id, num) {
  const outletCart = JSON.parse(localStorage.getItem("outlet-cart"));
  const productExist = outletCart.map((x) => x.product_id).indexOf(id);
  const priceItem = document.querySelector(`#price-${id}`);

  if (productExist >= 0) {
    outletCart[productExist]["product_qty"] += num;
    localStorage.setItem("outlet-cart", [JSON.stringify(outletCart)]);
    const price = outletCart[productExist]["product_qty"] * parseInt(outletCart[productExist]["product_price"]);
    const textPrice = new Intl.NumberFormat().format(price);
    priceItem.innerHTML = textPrice;
    countQty();
  }
}

function countQty() {
  const outletMoney = document.querySelector("#outlet-money");
  const outletCount = document.querySelectorAll(".cart__count-number.outlet-count");
  const outletCart = JSON.parse(localStorage.getItem("outlet-cart"));
  if (outletCart && outletCart.length > 0) {
    const totalPrice = outletCart.reduce((total, obj) => obj.product_qty * parseInt(obj.product_price) + total, 0);
    outletCount.forEach((item) => {
      item.innerHTML = outletCart.reduce((total, obj) => obj.product_qty + total, 0);
      item.classList.remove("hidden");
    });
    outletMoney.innerHTML = new Intl.NumberFormat().format(totalPrice);
  } else {
    outletMoney.innerHTML = 0;
    outletCount.forEach((item) => {
      item.classList.add("hidden");
    });
  }
}

function removeItem(id) {
  const data = document.querySelector(`#item-${id}`);
  data.remove();
  var outletCart = JSON.parse(localStorage.getItem("outlet-cart"));
  const productExist = outletCart.map((x) => x.product_id).indexOf(id);
  if (productExist >= 0) {
    outletCart.splice(productExist, 1);
    localStorage.setItem("outlet-cart", [JSON.stringify(outletCart)]);
    countQty();
  }
}

function removeQty(pro_id) {
  const data = document.querySelector(`#qty-${pro_id}`);
  let qty = Number(data.value);
  qty = qty - 1;
  if (qty == 0) {
    removeItem(pro_id);
  } else {
    data.value = qty;
    xuLyQty(pro_id, -1);
  }
}
function plusQty(pro_id, max_qty) {
  const data = document.querySelector(`#qty-${pro_id}`);
  let qty = Number(data.value);
  qty = qty + 1;
  if (qty <= max_qty) {
    data.value = qty;
    xuLyQty(pro_id, 1);
  }
}

function outletInfo() {
  this.btnInfo.classList.add("hidden");
  this.cartItemsHolder.classList.add("hidden");
  this.checkout.classList.remove("hidden");
  this.cartItemsInfo.classList.remove("hidden");
}

function outletBackCart() {
  this.btnInfo.classList.remove("hidden");
  this.cartItemsHolder.classList.remove("hidden");
  this.checkout.classList.add("hidden");
  this.cartItemsInfo.classList.add("hidden");
}

function outletCheckout() {
  this.outletLoading.classList.remove("hidden");
  this.outletNotification.classList.remove("hidden");
  let error = false;
  const dau_so = [
    "086",
    "087",
    "096",
    "097",
    "098",
    "032",
    "033",
    "034",
    "035",
    "036",
    "037",
    "038",
    "039",
    "089",
    "090",
    "093",
    "070",
    "079",
    "077",
    "076",
    "078",
    "088",
    "091",
    "094",
    "083",
    "084",
    "085",
    "081",
    "082",
    "092",
    "052",
    "056",
    "058",
    "099",
    "059",
  ];
  const inputName = document.querySelector("#cart-drawer-outlet #info__name").value.trim();
  const inputPhone = document.querySelector("#cart-drawer-outlet #info__phone").value.trim();
  const inputBoPhan = document.querySelector("#cart-drawer-outlet #info__bo-phan").value;
  const outletNote = document.querySelector("#cart-drawer-outlet #info__note").value;
  const nameError = document.querySelector("#cart-drawer-outlet .input-name-error");
  const phoneError = document.querySelector("#cart-drawer-outlet .input-phone-error");
  const bpError = document.querySelector("#cart-drawer-outlet .input-bp-error");

  nameError.classList.add("hidden");
  phoneError.classList.add("hidden");
  bpError.classList.add("hidden");

  if (inputName.length == 0) {
    error = true;
    nameError.classList.remove("hidden");
    nameError.innerHTML = "*Vui Lòng Nhập Tên";
  }
  if (inputPhone.length == 0) {
    error = true;
    phoneError.classList.remove("hidden");
    phoneError.innerHTML = "*Vui Lòng Nhập SĐT";
  } else if (inputPhone.length != 10) {
    error = true;
    phoneError.classList.remove("hidden");
    phoneError.innerHTML = "*SĐT không hợp lệ";
  } else if (!dau_so.includes(inputPhone.substr(0, 3))) {
    error = true;
    phoneError.classList.remove("hidden");
    phoneError.innerHTML = "*Đầu số không hợp lệ";
  }
  if (inputBoPhan.length == "") {
    error = true;
    bpError.classList.remove("hidden");
    bpError.innerHTML = "*Vui Chọn Bộ Phận";
  }
  const outletCart = JSON.parse(localStorage.getItem("outlet-cart"));
  if (outletCart == null || outletCart.length < 1) {
    this.outletNotification.querySelector(".title").innerHTML = "Lỗi";
    this.outletNotification.querySelector(".thong-bao").innerHTML = "Chưa có sản phẩm nào trong giỏ hàng !!!";
    this.outletNotification.querySelector("#thong-bao-loi").classList.remove("hidden");
    this.outletLoading.classList.add("hidden");
    this.outletContent.classList.remove("hidden");
  } else if (!error) {
    const body = { ten: inputName, phone: inputPhone, department_id: inputBoPhan, ip: "", origin: "web", note: outletNote, outlet_line: [] };
    outletCart.forEach((x) => {
      body["outlet_line"].push({ product_id: x.product_id, qty: x.product_qty, gia_goc: x.product_price_origin, gia_giam: x.product_price });
    });
    body["ip"] = this.textIP;
    fetch(`${window.theme.zuciani}/api/web/create_outlet_order`, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status) {
          this.outletNotification.querySelector(".title").innerHTML = "Thành công";
          this.outletNotification.querySelector(".thong-bao").innerHTML = "Đơn hàng của bạn: " + res.datas.outlet_name;
          this.outletNotification.querySelector("#thong-bao-hoan-thanh").classList.remove("hidden");
          localStorage.removeItem("outlet-cart");
        } else {
          this.outletNotification.querySelector(".title").innerHTML = "Lỗi";
          this.outletNotification.querySelector(".thong-bao").innerHTML = res.message;
          this.outletNotification.querySelector("#thong-bao-loi").classList.remove("hidden");
        }
        this.outletLoading.classList.add("hidden");
        this.outletContent.classList.remove("hidden");
      });
  } else {
    this.outletLoading.classList.add("hidden");
    this.outletNotification.classList.add("hidden");
  }
}

function notifiDone() {
  this.outletLoading.classList.add("hidden");
  this.outletNotification.classList.add("hidden");
  this.outletContent.classList.add("hidden");
  this.outletNotification.querySelector("#thong-bao-hoan-thanh").classList.add("hidden");
  this.outletNotification.querySelector("#thong-bao-loi").classList.add("hidden");
  this.outletNotification.querySelector("#tiep-tuc-mua").classList.add("hidden");
  location.reload();
}

function notifiEdit() {
  this.outletLoading.classList.add("hidden");
  this.outletNotification.classList.add("hidden");
  this.outletContent.classList.add("hidden");
  this.outletNotification.querySelector("#thong-bao-hoan-thanh").classList.add("hidden");
  this.outletNotification.querySelector("#thong-bao-loi").classList.add("hidden");
  this.outletNotification.querySelector("#tiep-tuc-mua").classList.add("hidden");
}

function getBoPhan() {
  const templateFilter = `
        <li class="collection__filter-tag collection__filter-tag--default">
            <input type="checkbox" class="filter__input filter_type" name="filter_type" value="filter_value" id="filter-filter_type-filter_value" onchange="clickFilter()"/><label class="filter__button" for="filter-filter_type-filter_value">filter_label (<b>filter_count</b>)</label>
        </li>
    `;
  let optionList = "";
  let filterCategList = "";
  let filterBrandList = "";

  const infoBP = document.querySelector("#info__bo-phan");
  const filterCateg = document.querySelector("#filter-categ");
  const filterBrand = document.querySelector("#filter-brand");

  fetch(`${window.theme.zuciani}/api/web/stock_outlet_v2?ip=${this.textIP}&group=${this.type}&limit=16`)
    .then((response) => response.json())
    .then((response) => {
      this.outletLoading.classList.add("hidden");
      console.log(window.theme.zuciani);
      console.log(response);
      if (response.status) {
        response.datas.list_department.forEach(function (params, index) {
          if (index == 0) {
            optionList += '<option value="" class>Bộ phận</option>';
          }
          optionList += `<option class="bo-phan-item" value="${params.id}">${params.name}</option>`;
        });
        infoBP.innerHTML = optionList;
        if (filterCateg) {
          response.datas.list_categ.forEach(function (params, index) {
            filterCategList += templateFilter
              .replaceAll("filter_type", "categ")
              .replaceAll("filter_value", params.id)
              .replaceAll("filter_label", params.name)
              .replaceAll("filter_count", params.total_template);
          });
          filterCateg.innerHTML = filterCategList;
        }
        if (filterBrand) {
          response.datas.list_brand.forEach(function (params, index) {
            filterBrandList += templateFilter
              .replaceAll("filter_type", "brand")
              .replaceAll("filter_value", params.id)
              .replaceAll("filter_label", params.name)
              .replaceAll("filter_count", params.total_template);
          });
          filterBrand.innerHTML = filterBrandList;
        }
        if (this.filterGrid) {
          this.nextPage = response.datas.curent_page + 1;
          this.totalPage = response.datas.total_page;
          if (this.nextPage > this.totalPage) {
            this.loadMore.classList.add("hidden");
          } else {
            this.loadMore.classList.remove("hidden");
          }
          handleData(response.datas.products, false);
          this.countMax.innerHTML = response.datas.total_row;
        }
        this.outletNotification.classList.add("hidden");
        endLoading(true);

        if (this.type) {
          const title = document.querySelector(".banner-image__text-container .text-reveal__cropper strong");
          if (title) {
            const name = this.type == "nam" ? " - Nam" : this.type == "nu" ? " - Nữ" : " - Trẻ em";
            title.textContent += name;
          }
        }
        if (sliderMaxValue < response.datas.max_price) {
          if (response.datas.max_price > 1000000) {
            minGap = 100000;
          }
          if (this.sliderOne) {
            sliderMaxValue = response.datas.max_price + 10000;
            sliderOne.max = response.datas.max_price + 10000;
            sliderTwo.max = response.datas.max_price + 10000;
            sliderTwo.value = response.datas.max_price + 10000;
            slideOne();
            slideTwo();
          }
        }
      } else {
        endLoading(false);
        this.outletNotification.querySelector(".title").innerHTML = "Lỗi";
        this.outletNotification.querySelector(".thong-bao").innerHTML = response.message;
        this.outletNotification.classList.remove("hidden");
        this.outletContent.classList.remove("hidden");
      }
    });
}

function getData(isXemThem) {
  startLoading();

  let categ_id = [];
  let brand_id = [];
  const keyword = document.querySelector("input#searchInput-outlet")?.value;
  const categHTML = document.querySelectorAll("input.filter__input.categ:checked");
  const brandHTML = document.querySelectorAll("input.filter__input.brand:checked");
  const price_from = Number(sliderOne.value) > 0 ? `&price_from=${sliderOne.value}` : "";
  const price_to = Number(sliderTwo.value) > 0 ? `&price_to=${sliderTwo.value}` : "";

  categHTML?.forEach((categ) => {
    categ_id.push(categ.value);
  });

  brandHTML?.forEach((brand) => {
    brand_id.push(brand.value);
  });
  fetch(
    `${window.theme.zuciani}/api/web/stock_outlet_v2?ip=${this.textIP}&group=${this.type}&limit=16&keyword=${keyword.trim()}&categ_id=${categ_id.toString()}&brand_id=${brand_id.toString()}&page=${this.nextPage}${price_from}${price_to}`,
  )
    .then((response) => response.json())
    .then((response) => {
      
      if (response.status) {
        this.nextPage = response.datas.curent_page + 1;
        this.totalPage = response.datas.total_page;
        if (this.nextPage > this.totalPage) {
          this.loadMore.classList.add("hidden");
        } else {
          this.loadMore.classList.remove("hidden");
        }
        this.countMax.innerHTML = response.datas.total_row;
        if (sliderMaxValue < response.datas.max_price) {
          if (response.datas.max_price > 1000000) {
            minGap = 100000;
          }
          if (this.sliderOne) {
            sliderMaxValue = response.datas.max_price + 10000;
            sliderOne.max = response.datas.max_price + 10000;
            sliderTwo.max = response.datas.max_price + 10000;
            sliderTwo.value = response.datas.max_price + 10000;
            slideOne();
            slideTwo();
          }
        }
        handleData(response.datas.products, isXemThem);
        endLoading(true);
      } else {
        endLoading(false);
        this.outletNotification.querySelector(".title").innerHTML = "Lỗi";
        this.outletNotification.querySelector(".thong-bao").innerHTML = response.message;
        this.outletNotification.classList.remove("hidden");
        this.outletContent.classList.remove("hidden");
      }
    });
}

function handleData(data, isXemThem) {
  let filterGridList = "";
  data.forEach((productItem, index_variant) => {
    const gridItemID = `${this.type}-${productItem.template_id}`;
    let html_price = "";
    let html_size = "";
    let html_color = "";
    let html_image = "";
    productItem.product_colors.forEach((color, index_color) => {
      html_color += getColorHTML(index_color, productItem.template_id, gridItemID, color.color, color.image_url);
      html_image += getImageHTML(index_color, color.color, color.image_url);
      color.product_variants.forEach((variant, index_variant) => {
        if (variant.size != null) {
          html_size += getSizeHTML(index_color, index_variant, productItem.template_id, variant.product_id, gridItemID, color.color, variant, variant.size);
        } else {
          html_size += getSizeNullHTML(index_variant, color.color, productItem.template_id, variant.product_id, variant);
        }
        html_price += getPriceHTML(index_color, index_variant, productItem.template_id, variant.product_id, variant.gia_giam, variant.gia_goc, variant.max_qty);
      });
    });
    filterGridList += getProductHTML(gridItemID, html_image, html_color, html_size, productItem.template_name, html_price);
  });
  if (isXemThem) {
    const htmlCurrent = this.filterGrid.innerHTML;
    this.filterGrid.innerHTML = htmlCurrent + filterGridList;
  } else {
    this.filterGrid.innerHTML = filterGridList;
  }
  setTimeout(() => {
    this.countCurrent.innerHTML = document.querySelectorAll("[data-product-block]").length;
  }, 500);
}

function getPriceHTML(index_color, index_variant, template_id, product_id, gia_giam, gia_goc, maxQty) {
  const giaGiam = Intl.NumberFormat().format(gia_giam);
  const giaGoc = Intl.NumberFormat().format(gia_goc);
  return `
        <div class="product-grid-item__price price ${index_color == 0 && index_variant == 0 ? "" : "hidden"}" data-template-id="${template_id}" data-product-id="${product_id}">
            <p class="price-outlet">
                <span style="color: #f94c43;">${giaGiam}₫</span>
                <span style=" text-decoration: line-through; ">${giaGoc}₫</span>
                <span>| SL: ${maxQty}</span>
            </p>
        </div>
    `;
}

function getSizeHTML(index_color, index_variant, template_id, product_id, gridItemID, color, variant, size) {
  return `
        <span class="btn__inner ${index_variant == 0 ? "is-check" : ""} ${index_color != 0 ? "hidden" : ""}" 
            data-color="${color}" data-template-id="${template_id}" 
            data-product-id="${product_id}" onclick="clickSize('${gridItemID}', '${color}', '${product_id}', '${template_id}')">
            <noscript>${JSON.stringify(variant)}</noscript>
            ${size}
        </span>
    `;
}

function getSizeNullHTML(index_variant, color, template_id, product_id, variant) {
  return `
        <span class="btn__inner opacity-0 ${index_variant == 0 ? "is-check" : ""}" 
            data-color="${color}" data-template-id="${template_id}" 
            data-product-id="${product_id}">
            <noscript>${JSON.stringify(variant)}</noscript>
        </span>
    `;
}

function getColorHTML(index_color, template_id, gridItemID, color, image_url) {
  const jsonColor = {
    bạc: "#e3e2df",
    bò: "#663727",
    cafe: "#a9825a",
    cam: "#ee8332",
    da: "#f5f5dc",
    hồng: "#d65e80",
    "hồng cam đất": "#CC8899",
    "hồng da": "#FEC7C0",
    kem: "#f9e3b7",
    "kem bóng": "#FFF8E6",
    nâu: "#9f5e42",
    nu: "#F2D2BD",
    rêu: "#535c39",
    tím: "#c4a4da",
    trắng: "#ffffff",
    vàng: "#f7d849",
    xám: "#98999b",
    xanh: "#1f273c",
    "xanh lá": "#296220",
    đen: "#000000",
    "đen bóng": "#000000",
    đỏ: "#de4037",
    "đỏ bóng": "df0000",
  };
  const colorLower = color ? color.toLowerCase() : color;
  const getHexColor = jsonColor[colorLower] ? jsonColor[colorLower] : "#ccc";
  const colorWhile = colorLower == "trắng" ? "color-while__border" : "";
  return `
        <div class="swatch__button" data-outlet-color-button data-color="${color}" data-tooltip="${color}" onclick="clickColor('${gridItemID}', '${color}', '${template_id}', '${image_url}')">
            <div
                class="swatch__label ${index_color == 0 ? "is-check" : ""}"
                data-swatch="${color}"
                style="--swatch: ${getHexColor};"
                >
                <div class="product-color ${colorWhile}"></div>
            </div>
        </div>
    `;
}

function getImageHTML(index_color, color, image_url) {
  return `
        <figure class="lazy-image background-size-cover product__media outlet-figure ${index_color == 0 ? "product__media--featured-visible" : ""}" data-product-image data-grid-image col data-color="${color}">
            <img src="${image_url}" alt="Outlet" width="100%" height="auto" loading="lazy"/>
        </figure>
    `;
}

function getProductHTML(gridItemID, html_image, html_color, html_size, html_title, html_price) {
  return `
        <div id="${gridItemID}" class="product-grid-item carousel__item one-quarter mobile--one-half is-selected" data-slide="" data-product-block="">
            <div class="product-grid-item__image outlet-item" data-product-media-container="">
                <div class="product__media__container">
                    <div class="product__media__holder aos-animate" data-aos="zoom-out" data-aos-easing="ease-out-sine" data-aos-duration="500" data-aos-delay="300">
                        <div class="product__media__image product__media__image--hover-none">
                            <div class="background-size-cover placeholder-svg--overlayed product__media image-media-item" aria-label="blank.svg?v=137076462089144180021724129805" role="img">
                                ${html_image}
                            </div>
                        </div>
                    </div>
        
                    <div class="product-grid-item__quick-buy aos-animate" data-aos="fade" data-aos-delay="300">
                        <span class="btn--quick pill" onclick="quickButton('${gridItemID}')">
                            <span class="btn__inner">
                                <span class="btn__text desktop">Thêm Vào Giỏ Hàng</span>
                                <span class="btn__text mobile">Mua ngay</span>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        
            <div class="product-grid-item__info product-grid-item__info--left aos-animate" data-aos="fade" data-aos-delay="300">
                <div class="product-grid-item__swatch swatch product-grid__swatch--rectangle">
                    ${html_color}
                </div>
                <div class="product-grid-item__size size product-grid__swatch--rectangle">
                    ${html_size}
                </div>
                <span class="product-grid-item__title font-body" href="#!" tabindex="-1">${html_title}</span>
                ${html_price}
            </div>
        </div>
    `;
}

function clickOpendFilterMobile() {
  this.bodyHTML.classList.add("overflow-hidden");
  this.collection__filters.classList.add("collection__filters--visible");
}

function clickCloseFilterMobile() {
  this.bodyHTML.classList.remove("overflow-hidden");
  this.collection__filters.classList.remove("collection__filters--visible");
}

function clickFilter() {
  this.nextPage = 1;
  this.collection__filters.classList.remove("collection__filters--visible");
  getData(false);
}

function startLoading() {
  this.bodyHTML.classList.add("overflow-hidden");
  this.outletLoading.classList.remove("hidden");
  this.outletNotification.classList.remove("hidden");
}

function endLoading(isOverflow) {
  if (isOverflow) {
    this.bodyHTML.classList.remove("overflow-hidden");
  }
  this.outletLoading.classList.add("hidden");
  this.outletNotification.classList.add("hidden");
}

function slideOne() {
  if (parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap) {
    sliderOne.value = parseInt(sliderTwo.value) - minGap;
  }
  displayValOne.textContent = Number(sliderOne.value).toLocaleString("vi-VN");
  fillColor();
}
function slideTwo() {
  if (parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap) {
    sliderTwo.value = parseInt(sliderOne.value) + minGap;
  }
  displayValTwo.textContent = Number(sliderTwo.value).toLocaleString("vi-VN");
  fillColor();
}
function fillColor() {
  percent1 = (sliderOne.value / sliderMaxValue) * 100;
  percent2 = (sliderTwo.value / sliderMaxValue) * 100;
  sliderTrack.style.background = `linear-gradient(to right, #d9d9d9 ${percent1}% , #dc232e ${percent1}% , #dc232e ${percent2}%, #d9d9d9 ${percent2}%)`;
}

function slideChange() {
  this.nextPage = 1;
  getData(false);
}
